module.exports = __webpack_public_path__ + "static/media/ha.aea9fa6f.png";